import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

export const authConfig: AuthConfig = {
	issuer: environment.authSettings.authority,
	redirectUri: `${window.location.origin}`,
	clientId: environment.authSettings.clientId,
	responseType: 'code',
	scope: environment.authSettings.scope,
	clearHashAfterLogin: false,
	strictDiscoveryDocumentValidation: false,
	useSilentRefresh: true,
	silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
	showDebugInformation: true
};
